import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LeadsService from '../../Services/LeadsService';
import PubSub from 'pubsub-js';
import csv2json from 'csvjson-csv2json';
import SequenceService from '../../Services/SequenceService';

function AdminUploadLeads({ onBack }) {
    const navigate = useNavigate();

    const [leadsText, setLeadsText] = useState('');
    const [leadsCount, setLeadsCount] = useState(0);

    const handleBack = onBack || (() => navigate('/admin/leads'));

    useEffect(() => {
        getLeadsCount();
    }, []);

    async function getLeadsCount() {
        let { count } = await LeadsService.getLeadsAvailableCount();
        setLeadsCount(count);
    }

    function mapLeads() {
        const json = csv2json(leadsText, { parseNumbers: true });
        return json;
    }

    async function uploadLeads() {
        let leadsMapped = mapLeads();
        console.log(leadsMapped);

        let leadsWithEmail = leadsMapped.filter(lead => lead.email);

        if (!leadsWithEmail.length) {
            PubSub.publish('show-basic-notification', {
                title: 'Error',
                message: 'No leads with email found'
            });
            return;
        }

        let { message, success } = await LeadsService.uploadLeadsUsingJSON(leadsWithEmail)

        if (success) {
            PubSub.publish('show-basic-notification', {
                title: 'Success, leads uploaded',
                message: message
            });
        } else {
            PubSub.publish('show-basic-notification', {
                title: 'Error',
                message: message
            });
        }

    }

    async function assignLeads() {

        let confirmMessage = 'Are you sure you want to assign the leads to the sequences and assign the dates to start sending the emails?';

        if (window.confirm(confirmMessage)) {
            PubSub.publish('loading.notification', {
                show: true,
                message: 'Assigning leads to all sequences...'
            });

            let { message } = await SequenceService.assignLeadsToAllSequences();

            PubSub.publish('loading.notification.hide', {});

            PubSub.publish('show-basic-notification', {
                title: 'Leads assigned to all sequences',
                message: message
            });
        }

    }

    return (
        <div className="container">
            <button onClick={handleBack} className="btn btn-link px-0 mb-3">
                <i className="fas fa-chevron-left me-2"></i>Back
            </button>

            {/* Header mejorado pero conservador */}
            <div className="bg-light rounded p-4 mb-4">
                <h2 className="mb-2">
                    <i className="fas fa-users text-primary me-2"></i>
                    Admin Leads
                </h2>
                <div className='small text-muted'>
                    Leads available: <span className='text-danger fw-bold fs-6'>{leadsCount}</span>
                </div>
            </div>

            <div className="row">
                <div className="col-4">
                    <div className="bg-white border rounded p-4">
                        <h4 className="mb-4">
                            <i className="fas fa-info-circle text-info me-2"></i>
                            Instructions to upload leads
                        </h4>

                        <div className="mb-4">
                            <p className='small mb-3'>Please use the following template to fill the leads data that you want to upload</p>

                            <a
                                target="_blank"
                                rel="noreferrer"
                                href="https://docs.google.com/spreadsheets/d/1igqND-RBpMiugcFK0rXyV0Jff7unnx8wa1QsbbhEgGQ/edit#gid=0"
                                className="btn btn-outline-primary btn-sm d-block w-100"
                            >
                                <i className="fas fa-download me-2"></i>
                                Leads Template
                            </a>
                        </div>

                        <hr className="my-4" />

                        <div className="mb-4">
                            <p className='small mb-3'>
                                After you fill the rows, please copy and paste them here in the following textarea
                            </p>
                        </div>

                        <hr className="my-4" />

                        <div className="mb-4">
                            <p className='small mb-3'>
                                Or if you prefer you can upload a CSV file with the leads data
                            </p>

                            <input type="file"
                                className='form-control form-control-sm'
                                accept=".csv"
                                onChange={(e) => {
                                    let file = e.target.files[0];
                                    let reader = new FileReader();
                                    reader.onload = function (e) {
                                        setLeadsText(e.target.result);
                                    }
                                    reader.readAsText(file);
                                }}
                            />
                        </div>

                        <div className="p-3 bg-light rounded">
                            <p className='small text-muted mb-0'>
                                <i className="fas fa-lightbulb text-warning me-2"></i>
                                The leads data will be uploaded to the database and will be available to use in the app
                            </p>
                        </div>
                    </div>
                </div>

                <div className="col-8">
                    <div className="bg-white border rounded p-3">
                        <h5 className="mb-3 text-muted">
                            <i className="fas fa-edit me-2"></i>
                            Paste your leads data here
                        </h5>
                        <textarea
                            rows="10"
                            value={leadsText}
                            onChange={(e) => setLeadsText(e.target.value)}
                            placeholder="Paste your CSV data here..."
                            className="form-control"
                            style={{ fontSize: '14px' }}
                        />

                        <button
                            onClick={uploadLeads}
                            disabled={!leadsText}
                            className="btn btn-success mt-3"
                        >
                            <i className="fas fa-upload me-2"></i>
                            Upload Leads
                        </button>
                    </div>
                </div>
            </div>

            <hr className='my-5' />

            <div className="bg-light rounded p-4">
                <h4 className="mb-3">
                    <i className="fas fa-cog text-secondary me-2"></i>
                    Additional options
                </h4>

                <div className='text-muted small mb-3'>
                    Click the button below to assign the leads to the sequences and assign the dates to start sending the emails
                </div>

                <button
                    onClick={assignLeads}
                    className="btn btn-primary"
                >
                    <i className="fas fa-users me-2"></i>
                    Assign leads and dates
                </button>
            </div>

            <br />
            <br />
        </div>
    )
}

export default AdminUploadLeads;
